import $ from "jquery";
import "popper.js";
import "bootstrap";
import "simplebar";
import { gsap, TweenMax, TimelineMax, CSSPlugin, Power0, Power1 } from "gsap";
import Draggable from "gsap/Draggable";
import InertiaPlugin from "gsap/InertiaPlugin";
gsap.registerPlugin(Draggable, InertiaPlugin);
import Swiper from "swiper";
import * as functions from "../js/extra/functions.js";

export var theObject = {
    workshopType: 0,

    client_id: -1,
    SelectedTopics: [],
    SelectedDocs: [],

    notSelectedIds: []
};

export var globals = {
    device: "",
    animating: false,
    filtermodal: false,
    dragDropFirst: true,
    shouldSkipClientSection: false
};

export var urls = {
    clients: `${baseUrl}/api/clientList/${workshopId}`,
    topicselect: `${baseUrl}/api/preferedTopics/${workshopId}`,
    docselect: `${baseUrl}/api/content/${workshopId}`,
    docRegeneration: `${baseUrl}/api/contentRefill/${workshopId}`,
    filterCats: `${baseUrl}/api/filterCategories/${workshopId}`,
    filterCatsRegenerate: `${baseUrl}/api/filterCategoriesRegenerate/${workshopId}`
    // clients:
    //     "https://fastinnovation.cloud/accenture/innovationathand/api-clients.php",
    // docselect:
    //     "https://fastinnovation.cloud/accenture/innovationathand/api-documents.php",
    // topicselect:
    //     "https://fastinnovation.cloud/accenture/innovationathand/api-agenda.php",
    // docRegeneration:
    //     "https://fastinnovation.cloud/accenture/innovationathand/api-doc-regeneration.php",
    // filterCats:
    //     "https://fastinnovation.cloud/accenture/innovationathand/api-filtercats.php",
    // filterCatsRegenerate:
    //     "https://fastinnovation.cloud/accenture/innovationathand/api-filtercats-regeneration.php"
};

$(document).ready(function() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    theObject.workshopType = workshopType;

    globals.device = functions.whichRatio();
    functions.initClients(urls);
    functions.homeAnimation();
    functions.pageTransition();
    functions.selectAnimation(); // Drag and drop hand animation
    functions.emailAnimation(); // Shapes animation of email
    functions.handModalAnimation();
    functions.hideTheModal($(".docmodal"));
    functions.mandatoryCheckbox();
    functions.filterButtonListener();
    functions.privacyPolicyInit();

    //functions.devGoToDocSelect();

    if (theObject.workshopType != 2) {
        $("#companyInput").css("display", "none");
    } else {
        $("#clientForm")
            .parent()
            .css("margin-top", "-40px");
        $("#clientForm")
            .parent()
            .parent()
            .css("padding-top", "15px");
        $("input").each(function() {
            $(this).css("margin-top", "1rem");
        });
    }

    console.log(urls);
});

if (process.env.NODE_ENV !== "development") {
    var angle = 0;
    if (typeof orientation !== "undefined") {
        angle = orientation;
    } else if (typeof screen.orientation !== "undefined") {
        angle = screen.orientation.angle;
    }
    if (window.screen.availWidth < 1440) {
        $(window).on("resize", function() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
            var newAngle = 0;
            if (typeof orientation !== "undefined") {
                newAngle = orientation;
            } else if (typeof screen.orientation !== "undefined") {
                newAngle = screen.orientation.angle;
            }
            if (angle != newAngle) {
                angle = newAngle;
                location.reload();
            }
        });
    }
}
